export type Tool = "Planable" | "Hootsuite" | "Metricool" | "Zoho Social" | "PostEverywhere" | "Buffer";

export function pick(a: Record<string, string>): Tool[] {
  const matches: Tool[] = [];
  if (a.approve === "yes") matches.push("Planable");
  if (a.report === "deep") matches.push("Hootsuite");
  if (a.report === "detailed") matches.push("Metricool");
  if (a.recycle === "yes") matches.push("Zoho Social");
  if (a.ai === "yes") matches.push("PostEverywhere");
  if (matches.length === 0) matches.push("Buffer");
  return matches;
}
